import React from 'react';
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider } from '@material-ui/core';
import withWidth from '@material-ui/core/withWidth';
import datatablesStyle from 'assets/jss/material-dashboard-pro-react/datatablesStyle';
import datatablesNoSelectStyle from 'assets/jss/material-dashboard-pro-react/datatableNoSelect';

import DataTableFooter from '../CustomTableFooter/DataTableFooter';

class DataTable extends React.Component {

    state = {
        page: 0
    }

    setResponsiveness = () => {        
        switch (this.props.width) {
            case 'xs':
                if (this.props[this.props.width]) {
                    this.options.responsive = this.props[this.props.width];
                }
                break;
            case 'sm':
                if (this.props[this.props.width]) {
                    this.options.responsive = this.props[this.props.width];
                }
                break;
            case 'md':
                if (this.props[this.props.width]) {
                    this.options.responsive = this.props[this.props.width];
                }
                break;
            case 'lg':
                if (this.props[this.props.width]) {
                    this.options.responsive = this.props[this.props.width];
                }
                break;
            case 'xl':
                if (this.props[this.props.width]) {
                    this.options.responsive = this.props[this.props.width];
                }
                break;
        }
    }

    options = {
        filter: true,
        //filterType: "dropdown",
        responsive: "stacked", //scroll
        textLabels: { body: { noMatch: this.props.emptyMessage || "No Results Found" } },
        selectableRows: 'none',
        customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => <DataTableFooter count={count} page={page} rowsPerPage={rowsPerPage} changeRowsPerPage={changeRowsPerPage} changePage={changePage} />,
        onSearchChange: () => this.setState({ page: 0 }),
        onFilterChange: () => this.setState({ page: 0 })
    };

    render() {
        this.options.page = this.state.page;
        this.options = { ...this.options, ...this.props.options };
        this.setResponsiveness();
        
        return (
            <MuiThemeProvider theme={this.props.themeStyle || ((this.options.rowPointers === true || (this.props.options || {}).onRowClick) ? datatablesStyle : datatablesNoSelectStyle)}>
                <MUIDataTable
                    {...this.props}
                    options={this.options}
                />
            </MuiThemeProvider>
        );
    }
}

export default withWidth()(DataTable);